import type { FormatterMap, RouteList } from '@grandvisionhq/frk-routing'
import { createSimpleFormatter } from '@grandvisionhq/frk-routing'
import { createCheckoutFormatters } from '@grandvisionhq/www-next/formatters'

export const localRouteFormatters: FormatterMap = {
  home: createSimpleFormatter('/'),
  'cart.overview': createSimpleFormatter('cart'),
  'appointments.book': createSimpleFormatter('book-appointment-v3'),
  'appointments.cancel': createSimpleFormatter('cancel-appointment'),
  'appointments.reschedule': createSimpleFormatter('reschedule-appointment'),
  'order.confirm': createSimpleFormatter('order/confirm'),
  ...createCheckoutFormatters({
    path: 'checkout',
    children: {
      login: 'login',
      shipping: 'leverans',
      overview: 'oversikt',
      payment: 'betalning',
    },
  }),
}

export const routes: RouteList = [
  ['/', 'home'],

  ['/checkout', 'checkout'],
  ['/checkout/callback', 'checkout'],
  ['/checkout/login', 'checkout.login'],
  ['/checkout/leverans', 'checkout.shipping'],
  ['/checkout/oversikt', 'checkout.overview'],
  ['/checkout/betalning', 'checkout.payment'],
  ['/checkout/genomford', 'checkout.complete'],
  ['/api/payment-callback', 'payment.callback'],
  ['/order/confirm', 'order.confirm'],

  ['/express-checkout', 'express-checkout'],

  ['/boka-tid/(.*)?', 'appointments.book'],
  ['/omboka-tid', 'appointments.reschedule'],
  ['/avboka-tid', 'appointments.cancel'],
]
